// ---------------------------------------------------------------------------
// Suspense wrapper
// ---------------------------------------------------------------------------

import FullScreenLoader from '@/components/feedback/FullScreenLoader';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export default function SuspenseOutlet() {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <Outlet />
    </Suspense>
  );
}
